import React from 'react';
import factory from 'components/Icons/factory';

export const Grid = factory(
  'Grid',
  <path d="M0 0h54v54H0zM0 74h54v54H0zM74 0h54v54H74zM74 74h54v54H74z" />
);

export default Grid;
